import React from "react";
import SearchableSelect from "./SearchableSelect";
import { IoCloseSharp } from "react-icons/io5";

const TagsInput = ({ tags = [], onTagsChange, availableTags = [] }) => {
    const removeTags = (tagToRemove) => {
        const newTags = tags.filter(tag => tag !== tagToRemove);
        onTagsChange(newTags);
    };

    return (
        <div style={{ padding: "12px", border: "1px solid #ccc", borderRadius: "4px" }}>
            <h4>Survey Tags (optional)</h4>
            <p className="mb-3" style={{ fontSize: "1.1rem" }}>Select existing tags or type to create new ones</p>
            
            {/* Show selected tags as bullet list */}
            {tags.length > 0 && (
                <ul className="mb-2">
                    {tags.map(tag => (
                        <li key={tag}>
                            <span>{tag}</span>
                            <IoCloseSharp 
                                onClick={() => removeTags(tag)} 
                                className="ms-2" 
                                style={{ cursor: "pointer" }}
                            />
                        </li>
                    ))}
                </ul>
            )}
            
            {/* SearchableSelect for adding tags */}
            <SearchableSelect
                options={availableTags}
                value={tags}
                onChange={onTagsChange}
                placeholder="Search or type to add tags..."
                getLabel={(tag) => tag}
                getValue={(tag) => tag}
                multiple={true}
                allowCreate={true}
            />
        </div>
    );
};
export default TagsInput;